/*
    Copyright 2021. Huawei Technologies Co., Ltd. All rights reserved.

    Licensed under the Apache License, Version 2.0 (the "License")
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

        https://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/
import {asyncExec} from "./utils";

let AGCCloudFunctions: string = "AGCCloudFunctions";
let CloudFunctionsModule: string = "CloudFunctionsModule";

export function call(triggerIdentifier: string, options?: AGCFunctionOptions): Promise<string> {
  return run("call", [{triggerIdentifier, options}]);
}

function run(funcName: string, args: any[] = [{}]) {
  return asyncExec(AGCCloudFunctions, CloudFunctionsModule, [funcName, args]);
}

export interface AGCFunctionOptions {
  timeout?: number,
  timeUnit?: AGCTimeUnit,
  params?: any
}
export enum AGCTimeUnit {
  NANOSECONDS = 0,
  MICROSECONDS = 1,
  MILLISECONDS = 2,
  SECONDS = 3,
  MINUTES = 4,
  HOURS = 5,
  DAYS = 6,
}
